export enum ProcedureObligationType {
    Recommended = 1,
    RequiredReadOnly = 2,
    RequiredFollowUp = 3,
    Extra = 4
}
